import { styled } from "@stitches/react";
import { Heading } from "@Forge/dist";

import SurgeonSearch from "@/components/SurgeonSearch";
import SurgeonList from "@/components/SurgeonList";

const SurgeonsWrapper = styled("div", {
  padding: "16px",
  height: "calc(100vh - 110px)",
  display: "flex",
  flexDirection: "column",
});

const Row = styled("div", {
  display: "flex",
  justifyContent: "space-between",
  gap: "24px",
  overflow: "hidden",
});

const MySurgeons = () => {
  return (
    <SurgeonsWrapper data-testid="surgeons-wrapper">
      <Heading text="My Surgeons" />
      <Row>
        {/* Search Surgeons */}
        <SurgeonSearch />
        {/* Subscribed Surgeons */}
        <SurgeonList />
      </Row>
    </SurgeonsWrapper>
  );
};

export default MySurgeons;
